export class VoipCallStartRequest {
  customerId?: number;
  voipInternalId?: number;
  phoneNumber?: string;
  internalNo?: string;
}
